import { render } from "./SearchManual.vue?vue&type=template&id=47fd9a08&scoped=true"
import script from "./SearchManual.vue?vue&type=script&lang=js"
export * from "./SearchManual.vue?vue&type=script&lang=js"

import "./SearchManual.vue?vue&type=style&index=0&id=47fd9a08&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47fd9a08"]])

export default __exports__